import { render, staticRenderFns } from "./chart-line-irrusage-hist.vue?vue&type=template&id=1ba05603"
import script from "./chart-line-irrusage-hist.vue?vue&type=script&lang=js"
export * from "./chart-line-irrusage-hist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports